angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/root/copy-project-url.html',
    '<div id="copyProjectUrl">\n' +
    '    <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '        <i class="fa fa-times"></i>\n' +
    '    </a>\n' +
    '    <div class="form-group">\n' +
    '        <h3>Project URL</h3>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <p class="input-group">\n' +
    '            <input id="projectUrl" ng-value="project.url" class="form-control input-lg">\n' +
    '            <span class="input-group-btn">\n' +
    '                <button uib-tooltip="Copied!" tooltip-is-open="popUp" tooltip-trigger="none" tooltip-placement="bottom"  id="btnClipboard" class="btn btn-input" data-clipboard-target="#projectUrl" ng-click="open()">\n' +
    '                    <i class="glyphicon glyphicon-copy" alt="Copy to clipboard"></i>\n' +
    '                </button>\n' +
    '            </span>\n' +
    '        </p>\n' +
    '        <a ng-click="goToUrl()" href="" class="btn btn-primary go-to-proj">View Project</a>\n' +
    '    </div>\n' +
    '</div>');
}]);
